import _extends from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["size", "color"];
var __jsx = React.createElement;
import React from 'react';
const DiscountTagFill = _ref => {
  let {
      size = "20",
      color = "currentColor"
    } = _ref,
    attributes = _objectWithoutProperties(_ref, _excluded);
  return __jsx("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, attributes), __jsx("path", {
    d: "M1.56211 20C0.996874 19.8598 0.51289 19.5711 0.227343 19.0496C0.120312 18.8539 0.092577 18.6699 -0.000391006 18.4766V10.7812C0.0972652 10.6461 0.110937 10.4824 0.187891 10.325C0.277735 10.1402 0.422266 9.98516 0.545704 9.82344L9.82305 0.546095C10.1273 0.256641 10.457 0.106642 10.8594 0.000391006H11.4844L12.0711 0.253515C14.6465 2.65 17.0723 5.2293 19.5902 7.69531C19.7973 7.9332 19.8707 8.23867 20 8.51602V9.21914C19.9023 9.3543 19.8887 9.51797 19.8117 9.67539C19.7219 9.86016 19.5773 10.0152 19.4539 10.177C16.2668 13.3301 13.1395 16.5484 9.91914 19.6656C9.69414 19.8352 9.43281 19.8941 9.1793 20H1.56211ZM3.79766 16.8676C4.47734 16.7738 4.44883 15.8012 3.84492 15.7059C2.88516 15.5543 2.95625 16.9836 3.79766 16.8676ZM10.2426 15.3797C12.559 15.1004 12.2621 11.4578 9.75039 11.7234C7.44531 11.9672 7.75195 15.6797 10.2426 15.3797ZM13.877 10.5766C14.5301 10.4293 14.4918 9.48711 13.8082 9.41406H6.19062C5.47617 9.49063 5.47617 10.5098 6.19062 10.5863L13.8766 10.577L13.877 10.5766ZM10.2816 8.27031C12.5465 7.99609 12.2359 4.36328 9.78945 4.61406C7.4375 4.85508 7.71836 8.58047 10.2816 8.27031Z",
    fill: color
  }));
};
export default DiscountTagFill;